import React, { Fragment } from "react";
import { useForm } from "react-hook-form";
import Error from "../../../utilities/Error";
import axios from "axios";

const AddDesignation = ({ handleBackToList, actionType, designationObj }) => {
  const { register, handleSubmit, errors } = useForm();

  const onSubmit = async (data) => {
    if (actionType === "add") {
      const result = await axios.post(
        `${process.env.REACT_APP_ENDPOINT_URL}/addDesignation`,
        {
          data: {
            designationName: data.designationName,
            designationHeirarchy: data.designationHeirarchy,
          },
        }
      );
      if (result != null && result != "") {
        handleBackToList("adddesignation");
      }
    } else if (actionType === "edit") {
      const result = await axios.post(
        `${process.env.REACT_APP_ENDPOINT_URL}/editDesignationDetails`,
        {
          data: {
            designationId: designationObj.designationId,
            designationName: data.designationName,
            designationHeirarchy: data.designationHeirarchy,
          },
        }
      );

      if (result != null && result != "") {
        handleBackToList("editdesignation");
      }
    }
  };

  const handleCancel = () => {
    handleBackToList();
  };
  return (
    <Fragment>
      {actionType === "add" ? (
        <div className="bg-white w-1/2 p-3 rounded-lg shadow-xl">
          <p className="text-lg text-left font-medium mb-3">Add Designation </p>
          <form onSubmit={handleSubmit(onSubmit)} className="text-left">
            <p>Designation name :</p>
            <input
              name="designationName"
              type="text"
              className={`border rounded-lg w-3/4 py-1.5 px-3 text-sm outline-none ${
                errors.designationName ? "border-red-700" : ""
              }`}
              ref={register({ required: true })}
            />
            {errors.designationName && (
              <Error message="Designation name is required" />
            )}
            <p className="mt-3">Designation heirarchy :</p>
            <input
              name="designationHeirarchy"
              type="number"
              className="border rounded-lg w-3/4 py-1.5 px-3 text-sm outline-none"
            />

            <br></br>
            <div className="flex justify-between">
              <button
                type="submit"
                className="bg-theme-green text-white focus:outline-none rounded-sm text-sm px-4 py-1 mt-2"
              >
                Submit
              </button>
              <button
                className="bg-gray-400 text-white focus:outline-none rounded-sm text-sm px-4 py-1 mt-2"
                onClick={handleCancel}
              >
                Cancel
              </button>
            </div>
          </form>
        </div>
      ) : (
        <div className="bg-white w-1/2 p-3 rounded-lg shadow-xl">
          <p className="text-lg text-left font-medium mb-3">Edit Designation</p>
          <form onSubmit={handleSubmit(onSubmit)} className="text-left">
            <input
              type="hidden"
              name="designationId"
              defaultValue={designationObj.designationId}
            />
            <p>Designation name :</p>
            <input
              name="designationName"
              type="text"
              defaultValue={designationObj.designationName}
              className={`border rounded-lg w-3/4 py-1.5 px-3 text-sm outline-none ${
                errors.designationName ? "border-red-700" : ""
              }`}
              ref={register({ required: true })}
            />
            {errors.designationName && (
              <Error message="Designation name is required" />
            )}
            <p className="mt-3">Designation heirarchy :</p>
            <input
              name="designationHeirarchy"
              type="number"
              defaultValue={designationObj.designationHeirarchy}
              className="border rounded-lg w-3/4 py-1.5 px-3 text-sm outline-none"
            />
            <br></br>
            <div className="flex justify-between">
              <button
                type="submit"
                className="bg-theme-green text-white focus:outline-none rounded-sm text-sm px-4 py-1 mt-2"
              >
                Submit
              </button>
              <button
                className="bg-gray-400 text-white focus:outline-none rounded-sm text-sm px-4 py-1 mt-2"
                onClick={handleCancel}
              >
                Cancel
              </button>
            </div>
          </form>
        </div>
      )}
    </Fragment>
  );
};

export default AddDesignation;
